import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-home-widget-top-post',
  templateUrl: './home-widget-top-post.component.html',
  styleUrls: ['./home-widget-top-post.component.scss']
})
export class HomeWidgetTopPostComponent {
  @Input() type: string = '';
  @Input() insight: string = '0';
  @Input() tab: any;
  isHovered: boolean = false;

  onHover(state: boolean): void {
    this.isHovered = state;
  }

  getToolTipText(tab:any): string {
    console.log("tab", tab);
    return "bla bla"
  }
}
